import { monthsInYear } from 'date-fns/constants'
import { format } from 'date-fns/format'

export function buildMonthRangeForSelect(monthFormat: string = 'MMMM') {
  return Array.from({ length: monthsInYear })
    .map(
      (_, x) => ({
        value: x + 1,
        text: format(`2020-${(x + 1).toString().padStart(2, '0')}-01`, monthFormat)
      })
    )
}


export function buildYearRange(startYear: number = 2011, endYear?: number) {
  return Array
    .from({ length: (endYear ?? new Date().getFullYear() + 6) - startYear + 1 })
    .map((_, x) => startYear + x)
}

export function buildYearRangeForSelect(startYear: number = 2011, endYear?: number) {
  return buildYearRange(startYear, endYear).map(x => ({ value: x, text: x.toString() }))
}

export function transformToSelectOptions<T extends object, K extends keyof T>(items: T[]|undefined|null, valueKey: K, textKey: K): { text: string, value: T[K] }[] {
  return (items || []).map(
    (item: T) => ({ text: item[textKey]?.toString() ?? '-', value: item[valueKey] })
  )
}
